var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',_vm._b({attrs:{"on":_vm.$listeners}},'h1',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }